import { useState, type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AppConfig } from '@/config/env';

interface QueryProviderProps {
    children: ReactNode;
}

export const QueryProvider = ({ children }: QueryProviderProps) => {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        refetchOnWindowFocus: false,
                        refetchOnReconnect: true,
                        refetchOnMount: false,
                        retry: AppConfig.isProd ? 2 : 0,
                        staleTime: 1000 * 60 * 5,
                        gcTime: 1000 * 60 * 10, // ⬅️ if using v4, change to cacheTime
                        meta: {
                            apiBase: AppConfig.apiBase,
                        },
                    },
                    mutations: {
                        retry: 0, // ⬅️ Prevent unwanted retry loops
                    },
                },
            })
    );

    return (
        <QueryClientProvider client={queryClient}>
            {children}

            {/* {AppConfig.isDev && <ReactQueryDevtools initialIsOpen={false} />} */}
        </QueryClientProvider>
    );
};
